<div class="gc-dg-w-full">
    <div class="gc-payment-heading">
        <h2 id="gc-dg-payment-options" class="gc-dg-d-inline">
            Select a payment option
        </h2>
        <div class="gc-dg-d-inline gc-dg-float-right gc-dg-mt-6">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
            >
                <g clip-path="url(#gc-dg-clip0_1081_23275)">
                    <path
                        d="M6.87646 9.07861V6.57861C6.87646 3.84424 9.10303 1.57861 11.8765 1.57861C14.6108 1.57861 16.8765 3.84424 16.8765 6.57861V9.07861H17.5015C19.2202 9.07861 20.6265 10.4849 20.6265 12.2036V18.4536C20.6265 20.2114 19.2202 21.5786 17.5015 21.5786H6.25146C4.49365 21.5786 3.12646 20.2114 3.12646 18.4536V12.2036C3.12646 10.4849 4.49365 9.07861 6.25146 9.07861H6.87646ZM8.12646 9.07861H15.6265V6.57861C15.6265 4.5083 13.9468 2.82861 11.8765 2.82861C9.76709 2.82861 8.12646 4.5083 8.12646 6.57861V9.07861ZM4.37646 18.4536C4.37646 19.5083 5.19678 20.3286 6.25146 20.3286H17.5015C18.5171 20.3286 19.3765 19.5083 19.3765 18.4536V12.2036C19.3765 11.188 18.5171 10.3286 17.5015 10.3286H6.25146C5.19678 10.3286 4.37646 11.188 4.37646 12.2036V18.4536Z"
                        fill="black"
                    />
                </g>
                <defs>
                    <clipPath id="gc-dg-clip0_1081_23275">
                        <rect
                            width="24"
                            height="24"
                            fill="white"
                            transform="translate(0.126465 0.0786133)"
                        />
                    </clipPath>
                </defs>
            </svg>
        </div>
    </div>

    <div class="gc-dg-bg-secondary-grey">
        <div
            class="gc-dg-tabs"
            role="tablist"
            aria-labelledby="gc-dg-payment-options"
        >
            <button
                id="gc-dg-ach-tab"
                class="gc-dg-tab-link gc-dg-text-md gc-dg-font-semibold"
                data-tab="ach"
                role="tab"
                aria-controls="gc-dg-ach"
            >
                ACH (Bank account)
            </button>
            <button
                id="gc-dg-card-tab"
                class="gc-dg-tab-link gc-dg-text-md gc-dg-font-semibold"
                data-tab="card"
                role="tab"
                aria-controls="gc-dg-card"
            >
                Credit card
            </button>
        </div>

        <div
            data-gc-dg-element="gc-dg-ach-payment-tab"
            id="gc-dg-ach"
            class="gc-dg-tab-content gc-dg-p-5 gc-dg-text-md"
            role="tabpanel"
            tabindex="0"
            aria-labelledby="gc-dg-ach-tab"
        >
            <div
                data-gc-dg-element="gc-dg-ach-payment-discount-banner"
                class="gc-dg-mb-5 gc-dg-mt-5 gc-dg-text-md"
            >
                <span
                    >Monthly payment of $<span
                        class="gc-dg-ach-basket-monthly-total"
                    ></span
                ></span>
                <span
                    class="gc-dg-discount-box gc-dg-py-1 gc-dg-px-2 gc-dg-discount-details gc-dg-ach-price gc-dg-show-discount"
                    >Saving <span class="gc-dg-discount"></span>%</span
                >
            </div>
            <form
                id="gc-dg-paymentForm"
                role="form"
                aria-label="ACH payment form"
            >
                <label
                    class="gc-dg-mb-0 gc-dg-line-height-2"
                    for="gc-dg-accountNumber"
                    >Account Number</label
                >
                <input
                    type="text"
                    name="gc-dg-accountNumber"
                    id="gc-dg-accountNumber"
                    maxlength="17"
                    class="gc-dg-d-block gc-dg-mb-5 gc-dg-ac-no-input gc-dg-input"
                />
                <p
                    id="gc-dg-accountNumberError"
                    role="alert"
                    class="gc-dg-error-message gc-dg-hidden"
                >
                    Please enter a valid account number
                </p>
                <label
                    class="gc-dg-mb-0 gc-dg-line-height-2"
                    for="gc-dg-routingNumber"
                    >Routing Number</label
                >
                <input
                    type="text"
                    name="gc-dg-routingNumber"
                    id="gc-dg-routingNumber"
                    maxlength="9"
                    class="gc-dg-d-block gc-dg-sort-code-input gc-dg-input"
                />
                <p
                    id="gc-dg-routingNumberError"
                    role="alert"
                    class="gc-dg-error-message gc-dg-hidden"
                >
                    Please enter a valid routing number
                </p>
            </form>
        </div>

        <div
            data-gc-dg-element="gc-dg-card-payment-tab"
            id="gc-dg-card"
            class="gc-dg-tab-content gc-dg-p-5"
            role="tabpanel"
            tabindex="0"
            aria-labelledby="gc-dg-card-tab"
        >
            <div class="gc-dg-font-md gc-dg-font-semibold gc-dg-mb-5">
                Monthly payment of $<span
                    class="gc-dg-basket-monthly-total gc-dg-base-price"
                ></span>
            </div>
            <div
                class="gc-dg-d-flex gc-dg-offer-notification gc-dg-discount-details gc-dg-show-discount"
            >
                <svg
                    viewBox="0 0 180 270"
                    width="25px"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M46.5625 54.1426C46.5625 56.2871 44.6562 57.9551 42.5117 57.9551C40.6055 57.9551 38.9375 56.2871 38.9375 54.1426V27.4551C38.9375 25.5488 40.6055 23.6426 42.75 23.6426C44.6562 23.6426 46.5625 25.5488 46.5625 27.4551V54.1426ZM37.0312 69.3926C37.0312 66.2949 39.4141 63.6738 42.75 63.6738C45.8477 63.6738 48.4688 66.2949 48.4688 69.3926C48.4688 72.7285 45.8477 75.1113 42.75 75.1113C39.4141 75.1113 37.0312 72.7285 37.0312 69.3926ZM72.0586 13.1582C80.1602 21.0215 84.6875 31.7441 84.6875 43.1816C84.6875 53.4277 80.875 63.1973 74.2031 71.0605C71.1055 74.6348 65.625 82.7363 63.7188 89.4082C63.4805 91.3145 61.8125 92.5059 59.9062 92.5059C59.9062 92.5059 59.668 92.5059 59.4297 92.5059C57.2852 92.2676 55.8555 90.123 56.0938 88.2168L56.332 87.2637C58.7148 78.9238 64.9102 69.8691 68.4844 66.0566C73.9648 59.623 77.0625 51.5215 77.0625 43.1816C77.0625 33.8887 73.25 25.0723 66.8164 18.6387C60.3828 11.9668 51.8047 8.63086 42.75 8.63086H42.5117C23.4492 8.63086 8.4375 23.8809 8.4375 43.1816C8.4375 51.5215 11.2969 59.623 16.7773 65.8184C20.3516 69.8691 26.5469 78.9238 28.9297 87.2637L29.168 88.2168C29.168 90.123 27.7383 92.0293 25.5938 92.2676C23.6875 92.5059 21.7812 91.0762 21.543 89.1699C19.6367 82.7363 14.1562 74.6348 11.0586 70.8223C4.38672 63.1973 0.8125 53.4277 0.8125 43.1816C0.8125 19.8301 19.3984 1.00586 42.5117 1.00586C53.4727 0.529297 64.1953 5.29492 72.0586 13.1582ZM57.7617 99.8926C59.9062 99.8926 61.5742 101.799 61.5742 103.943V109.186C61.5742 110.377 61.0977 112.283 60.3828 113.475L56.332 119.432C55.1406 121.338 52.2812 122.768 49.8984 122.768H35.3633C32.9805 122.768 30.1211 121.338 28.9297 119.193L24.8789 113.236C23.9258 111.807 23.6875 110.377 23.6875 108.947V103.705C23.6875 101.561 25.3555 99.8926 27.5 99.8926H57.7617ZM53.9492 109.186C53.9492 109.186 53.9492 108.947 54.1875 108.947V107.518H31.3125V109.186L35.3633 115.143L35.6016 115.381L49.8984 115.143C49.8984 115.143 50.1367 115.143 50.1367 114.904L53.9492 109.186Z"
                        fill="#000000"
                    ></path>
                </svg>
                <span data-gc-dg-element="gc-dg-cc-offer-ach-discount-banner"
                    >Don't miss out! You'll save
                    <span class="gc-dg-font-semibold"
                        ><span class="gc-dg-discount"></span>% off the first 6
                        months</span
                    >
                    when paying by ACH.</span
                >
            </div>

            <!-- Create divs for the payment fields -->
            <label class="gc-dg-line-height-2" for="card-number"
                >Card Number</label
            >
            <div id="gc-dg-cardNumber" class="gc-dg-paysafe-field"></div>
            <p
                id="gc-dg-card-number-error"
                class="gc-dg-error-message gc-dg-hidden"
                role="alert"
            >
                Please enter a valid card number
            </p>
            <label class="gc-dg-line-height-2" for="expiry-date"
                >Expiry Date</label
            >
            <div id="gc-dg-expiryDate" class="gc-dg-paysafe-field"></div>
            <p
                id="gc-dg-expiry-date-error"
                class="gc-dg-error-message gc-dg-hidden"
                role="alert"
            >
                Please enter a valid expiry date
            </p>
            <label class="gc-dg-line-height-2" for="cvv">CVV</label>
            <div id="gc-dg-cvv" class="gc-dg-paysafe-field"></div>
            <p
                id="gc-dg-cvv-error"
                class="gc-dg-error-message gc-dg-hidden"
                role="alert"
            >
                Please enter a valid CVV number
            </p>
        </div>
        <div class="gc-dg-p-5">
            <h4 class="gc-dg-font-semibold gc-dg-font-lg">
                Please read and provide consent
            </h4>
            <div class="gc-dg-mb-5">
                <div class="gc-dg-d-flex">
                    <div>
                        <input
                            type="checkbox"
                            id="gc-dg-tandc"
                            name="gc-dg-tandc"
                            class="gc-dg-checkbox-input gc-dg-mr-3"
                        />
                    </div>

                    <label for="gc-dg-tandc"
                        >I agree to the Terms of Use and acknowledge the privacy
                        policy of Domestic & General</label
                    >
                </div>
                <p
                    id="gc-dg-termsAndConditionsError"
                    class="gc-dg-error-message gc-dg-hidden"
                    role="alert"
                >
                    Please agree to the terms and conditions in order to set up
                    your protection
                </p>
            </div>
            <div>
                <div class="gc-dg-d-flex">
                    <div>
                        <input
                            type="checkbox"
                            id="gc-dg-renew"
                            name="gc-dg-renew"
                            class="gc-dg-checkbox-input gc-dg-mr-3"
                        />
                    </div>

                    <label for="gc-dg-renew">
                        By checking this box, I am providing consent to the
                        automatic monthly renewal feature of this plan.</label
                    >
                </div>
            </div>
        </div>
    </div>
</div>
